import moment from "moment";
import "moment/locale/es";
import "moment/locale/en-gb";
import "moment/locale/fr";


const GetLocale = () =>{
  
  const language = localStorage.getItem('language-partes');

  switch (language) {
    case 'ES': return 'es'
    case 'GB': return 'en-gb'
    case 'FR': return 'fr'
    default: return 'es'
  }
}

export const GetAllMonths = ()=>{
  const locale = GetLocale();

  return Array.apply(0, Array(12)).map((value, i)=>NombreMes(i+1))
}

export const CreateFechaMoment = (fecha, locale) => {
  let inputFormat = "DD/MM/YYYY";
  if(typeof fecha !== 'string') fecha = fecha.format(inputFormat);
  if (fecha && fecha.indexOf("/") === -1) {
    inputFormat = "YYYYMMDD";
  }

  if (locale) {
    return fecha ? moment(fecha, inputFormat).locale(locale) : moment().locale(locale);
  } else {
    return fecha ? moment(fecha, inputFormat) : moment();
  }
};

export const InicioAño = (fecha) => {
  return CreateFechaMoment(fecha).startOf("year").format("DD/MM/YYYY");
};

export const InicioMes = (fecha) => {
  return CreateFechaMoment(fecha).startOf("month");
};

export const FinMes = (fecha) => {
  return CreateFechaMoment(fecha).endOf("month");
};

export const NombreMes = (indiceMes) => {
  let strMes = moment().locale(GetLocale()).month(indiceMes - 1).format("MMMM");
  return (strMes.charAt(0).toUpperCase() + strMes.slice(1));
}
  
//CreateFechaMoment().month(indiceMes - 1).format("MMMM").toUpperCase();

export const ToSQL = (fecha,separacion) => {
  separacion = separacion === undefined ? "" : separacion;
  if (typeof fecha === "string") {
    return CreateFechaMoment(fecha).format("YYYY"+separacion+"MM"+separacion+"DD");
  } else {
    return fecha.format("YYYY"+separacion+"MM"+separacion+"DD");
  }
};

export const NumeroDiasEnPeriodo = (fechaInicio, fechaFin) => {
  if (!fechaInicio && !fechaFin) return 0;

  let momentInicio, momentFin, numberOfDays;

  if (fechaInicio && !fechaFin) {
    momentInicio = InicioAño(fechaInicio);
    momentFin = CreateFechaMoment(fechaInicio);
  } else {
    momentInicio = CreateFechaMoment(fechaInicio);
    momentFin = CreateFechaMoment(fechaFin);
  }

  numberOfDays = momentFin.diff(momentInicio, "days") + 1;

  if (isNaN(numberOfDays)) {
    throw new Error("El formato de alguna de las fechas no es correcto");
  }

  return numberOfDays;
};

export const DiasMes = (periodo) =>{
  return moment(periodo).daysInMonth();
}

export const FechaPdf = () => {
  return moment().format("dddd, D MMMM, YYYY");
};

export const CreateFecha = (fecha) => {
  return moment(fecha).format("L");
};

export const formatDate = (value) => {
  return moment(value).format("DD/MM/YYYY");
};

export const FechaConHora = (value) => {
  return `${moment(value).format("L")} ${moment(value).format("LTS")}`;
};

export const FechaHoy = () => {
  return moment().format('L');
}

export const FechaHoyMesPosterior = (fecha) => {
  let fechaMoment = (fecha!==null && fecha!==undefined)? moment(fecha):moment();
  return fechaMoment.add(1, 'M').format('L');
}

export const DiferenciaEnMeses = (compareDate) => {
  let now = moment(Date.now()).format("YYYY/MM/DD");
  let compare = moment(compareDate).format("YYYY/MM/DD");

  now = moment(now.split("/"));
  compare = moment(compare.split("/"));

  return now.diff(compare, "month", true);
};

export const DATE_TIME_FORMAT = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
};

export const DATE_FORMAT = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const DATE_FORMAT_UTC = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  timeZone: "UTC",
};

export const DateTimeFormatter = (format, locale = "es-ES") => Intl.DateTimeFormat(locale, format);

/**
 * Returns
 *
 *  1 si date1 es mayor
 *
 *  0 si date1  y date2 son iguales
 *
 *  -1 si date1 es menor
 *
 * @param {Date} date1
 * @param {Date} date2
 */
export const DateTimeComparer = (date1, date2) => {

  const time1 = date1.getTime();
  const time2 = date2.getTime();

  if (time1 > time2) {
    return 1;
  } else if (time1 < time2) {
    return -1;
  }

  return 0;
};

// /**
//  * Returns
//  *
//  *  1 si date1 es mayor
//  *
//  *  0 si date1  y date2 son iguales
//  *
//  *  -1 si date1 es menor
//  *
//  * @param {Date} date1
//  * @param {Date} date2
//  */
// export const DateComparer = (date1, date2) => {
//   //console.log("TCL: DateTimeComparer -> date1, date2", [date1, date2]);

//   clearTime(date1);
//   clearTime(date2);

//   // console.log("TCL: DateTimeComparer after clear-> date1, date2", [
//   //   date1,
//   //   date2
//   // ]);

//   const time1 = date1.getTime();
//   const time2 = date2.getTime();

//   if (time1 > time2) {
//     return 1;
//   } else if (time1 < time2) {
//     return -1;
//   }

//   return 0;
// };

/**
 * Returns
 *
 *  1 si date1 es mayor
 *
 *  0 si date1  y date2 son iguales
 *
 *  -1 si date1 es menor
 *
 * @param {Date} date1
 * @param {Date} date2
 */
export const DateComparer = (fecha1, fecha2) => {
  let date1 = typeof fecha1 === 'string' ? stringToDate(fecha1) : fecha1;
  let date2 = typeof fecha2 === 'string' ? stringToDate(fecha2) : fecha2;

  clearTime(date1);
  clearTime(date2);

  const time1 = date1.getTime();
  const time2 = date2.getTime();

  if (time1 > time2) {
    return 1;
  } else if (time1 < time2) {
    return -1;
  }

  return 0;
};

/**
 *
 * Devuelve la fecha en formato AAAAMMDD
 *
 * @param {Date} date
 */
export const sqlDateFormat = (date) =>
  DateTimeFormatter(DATE_FORMAT)
    .formatToParts(date)
    .filter((f) => f.type !== "literal")
    .map((m) => m.value)
    .reverse()
    .join("");

/**
 *
 * Elimina la parte de tiempo de la fecha
 *
 * @param {Date} date
 */
const clearTime = (date) => {
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
};

export const isoStringToDate = (string) => {
  if (!string || string.length === 0) {
    return "";
  }

  return new Date(string);
};

export const isoStringToDateString = (dateString, format) => {
  if (!dateString || dateString.length === 0) {
    return "";
  }

  return DateTimeFormatter(format).format(isoStringToDate(dateString));
};

export const stringToISODate = (string) => new Date(Date.parse(string.split("/").reverse().join("-"))).toISOString();

export const stringToDate = (string) => {
  const isISOstring = (string) => string.indexOf("T") !== -1;
  const hasUTCCharacter = (string) => string.indexOf("Z") !== -1;
  const formatDate = (stringDate) => {
    if (hasUTCCharacter(stringDate)) {
      return stringDate;
    }

    const formatedDate = isISOstring(stringDate) ? stringDate + "Z" : stringDate.split("/").reverse().join("-");
    return new Date(formatedDate).toISOString();
  };

  return new Date(formatDate(string));
};

//export const stringToDate = (string) => new Date(Date.parse(string.split("/").reverse().join("-")));
